import { InnerContentItem } from "@certn/cascadia-react";
import { LabelAlign } from "@certn/cascadia-react/components/types";
import { slugify } from "@certn/utils";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

interface Props extends PropsWithChildren {
  label: string;
  labelAlign?: LabelAlign;
}

export function SummaryItem(props: Props) {
  const { t } = useTranslation();

  return (
    <InnerContentItem
      key={slugify(props.label)}
      label={props.label}
      testID={`summary-item-${slugify(props.label)}`}
      labelAlign={props.labelAlign}
    >
      {props.children || t("None provided")}
    </InnerContentItem>
  );
}
